mutation EntityDocumentVerify($input: EntityDocumentVerifyInput!) {
  entityDocumentVerify(input: $input) {
    selectedEntities {
      id
      rowTimestamp
    }
  }
}
